import { createRoutine } from "redux-saga-routines";
import * as types from "./types";
import { createAction } from "redux-actions";
export const getPL = createRoutine(types.GET_PL);
export const savePL = createRoutine(types.SAVE_PL);

export const clearResponsePL = createAction(types.CLEAR_RESPONSE_PL);


